import React from "react";
const PDFViewer = ({ base64 }) => {
  const pdfSource = `data:application/pdf;base64, ${base64}`;

  return <iframe src={pdfSource} width="100%" height="100%" />;
};

export default PDFViewer;
